import { motion } from 'framer-motion';
import React from 'react';

import { logger } from '../../lib/logger';

const headerLogger = logger.child('[NodeHeader]');

interface NodeHeaderProps {
  title: string;
  label?: string;
  guidanceText?: string;
}

export const NodeHeader = React.memo(function NodeHeader({
  title,
  label,
  guidanceText,
}: NodeHeaderProps) {
  headerLogger.debug('Rendered');

  return (
    <motion.div
      className="mb-6"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* Unified Header Banner */}
      <div className="bg-gradient-to-r from-[#0a0a0a] via-[#0f1419] to-[#080808] border border-[#2a2f35] rounded-xl p-6 shadow-[0_0_40px_rgba(79,70,229,0.15)] relative overflow-hidden">
        {/* Background Blur Orbs */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-[#4f46e5] opacity-10 rounded-full blur-[100px] transform -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-[#06b6d4] opacity-10 rounded-full blur-[80px] transform translate-x-1/2 translate-y-1/2" />

        {/* Content */}
        <div className="relative z-10">
          {/* Title with Gradient Effect */}
          <h1 className="text-2xl font-bold text-balance uppercase tracking-wide mb-2">
            <span className="bg-gradient-to-r from-[#4f46e5] to-[#06b6d4] bg-clip-text text-transparent">
              {title}
            </span>
          </h1>

          {/* Subtitle */}
          {label && <p className="text-sm text-[#06b6d4] font-medium text-balance mb-4">{label}</p>}

          {/* Guidance Text Integrated */}
          {guidanceText && (
            <div className="bg-black/20 backdrop-blur-sm rounded-lg p-4 border border-[#4f46e5]/20">
              <div className="text-gray-200 text-xs leading-snug max-h-[12lh] overflow-y-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-[#4f46e5]/50 hover:scrollbar-thumb-[#4f46e5]/70">
                <span className="font-semibold text-[#06b6d4] mr-2">Purpose:</span>
                <span
                  className="text-balance"
                  style={{ whiteSpace: 'pre-line', textWrap: 'balance' }}
                >
                  {guidanceText.replace(/\n\n/g, '\n\n')}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Bottom Gradient Accent */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#4f46e5] to-[#06b6d4] opacity-50" />
      </div>
    </motion.div>
  );
});
